import * as React from 'react';

export const IconTelehealth = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.802 36.913c10.102 0 18.291-8.189 18.291-18.29C37.093 8.52 28.904.33 18.803.33 8.7.33.51 8.52.51 18.622c0 10.102 8.19 18.291 18.291 18.291Z"
      fill="#D73D00"
    />
    <path fill="#fff" d="M12.514 9.477h12.575v17.72H12.514z" />
    <path
      d="M23.79 7.762h-9.976c-.497 0-.972.221-1.323.615-.351.395-.548.93-.548 1.487V27.38c0 .557.197 1.092.548 1.486.35.394.826.616 1.323.616h9.977c.496 0 .972-.222 1.322-.616a2.24 2.24 0 0 0 .548-1.486V9.864c0-.558-.197-1.092-.548-1.487a1.773 1.773 0 0 0-1.322-.615Zm1.248 18.568a.373.373 0 0 1-.091.247.296.296 0 0 1-.221.103H12.878a.295.295 0 0 1-.22-.103.373.373 0 0 1-.092-.247V10.214c0-.093.033-.182.092-.248a.295.295 0 0 1 .22-.102h11.848c.083 0 .162.037.22.102a.373.373 0 0 1 .092.248V26.33Z"
      fill="#04B9B9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.852 15.193a.457.457 0 0 0-.457.457v1.565H15.83a.457.457 0 0 0-.457.457v1.9c0 .252.204.457.457.457h1.565v1.566c0 .252.205.457.457.457h1.9a.457.457 0 0 0 .457-.457v-1.566h1.566a.457.457 0 0 0 .457-.457v-1.9a.457.457 0 0 0-.457-.457h-1.566V15.65a.457.457 0 0 0-.457-.457h-1.9Z"
      fill="#D73D00"
    />
  </svg>
);
